exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.disabled[data-v-8ccf8fb0] {\n  pointer-events: none;\n  opacity: 0.6;\n}", ""]);

// exports
